import { render } from "./PassageRangeWidget.vue?vue&type=template&id=398973d8&scoped=true"
import script from "./PassageRangeWidget.vue?vue&type=script&lang=js"
export * from "./PassageRangeWidget.vue?vue&type=script&lang=js"

import "./PassageRangeWidget.vue?vue&type=style&index=0&id=398973d8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398973d8"]])

export default __exports__